module.exports = __webpack_public_path__ + "static/media/placeholder.80f256d1.jpg";